<template>
  <div class="ep-tabs__row ep-tabs_bg-secondary ep-tabs_rounded-md">
    <div
      v-for="(item, index) in tabs"
      :key="index"
      :class="[
        classes,
        activeTab() === index ? activeClass: ''
      ]"
      @click="callback(index)"
    >
      <slot name="item" :item="item">
        {{ item }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabItem",
  props: {
    classes: {
      type: Array,
      default: () => []
    },
    activeClass: {
      type: String,
      default: () => ""
    },
    tabs: {
      type: Array,
      default: () => []
    },
    callback: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  inject: ["activeTab"]
};
</script>
